import { queryClient } from '@src/configs/tanstack.configs';
import { I18NEXUS_API_KEY, QUERY_KEYS, STORAGE_KEY } from '@src/constants';

import { decryptString, encryptString } from './code.helpers';
import { clearDiscountSession } from './discount.helpers';

export const resetQuizStates = (callback?: () => void) => {
  localStorage.removeItem(STORAGE_KEY.DATA);
  queryClient.resetQueries({ queryKey: [QUERY_KEYS.quizState] });
  clearDiscountSession();
  sessionStorage.removeItem(STORAGE_KEY.PROMO_CODE);
  callback?.();
};

export const saveToLocaleWithEncryption = async (
  key: string,
  value: unknown,
) => {
  const encrypted = await encryptString(
    JSON.stringify(value),
    I18NEXUS_API_KEY,
  );

  localStorage.setItem(key, encrypted);
};

export const getDataLocaleWithEncryption = async <T = unknown>(
  key: string,
): Promise<T | undefined> => {
  const encrypted = localStorage.getItem(key);
  if (!encrypted) return;

  const decrypted = await decryptString(encrypted, I18NEXUS_API_KEY);

  return JSON.parse(decrypted) as T;
};
